// extracted by mini-css-extract-plugin
module.exports = {"selectWrap":"SelectArea_selectWrap__3In1O","selcetText":"SelectArea_selcetText__3-xpJ"};